module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApplicationLoaded) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalApplication"
    }
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error.label) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.headerLabel) + ": " + _vm._s(_vm.application.lodgement_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                   Submission \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.application.submitter.first_name) + " " + _vm._s(_vm.application.submitter.last_name) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)) + "\n                        ")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.application.processing_status.name) + " " + _vm._s(_vm.hasCurrentLicence ? '' : '(attn: No Active License)') + " "), _c('br'), _vm._v(" "), _vm._l((_vm.licence_type_data), function(item) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((item), function(item1) {
      return _c('div', [(item1.name) ? _c('div', [_c('strong', [_vm._v(_vm._s(item1.name) + ": ")]), _vm._v(_vm._s(item1.processing_status.name) + "\n                                    ")]) : _vm._e()])
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToOfficer),
      expression: "showAssignToOfficer"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Officer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedActivity.assigned_officer),
        expression: "selectedActivity.assigned_officer"
      }],
      ref: "assigned_officer",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedActivity, "assigned_officer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.selectedActivity.licensing_officers), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignToMe()
        }
      }
    }, [_vm._v("Assign to me")])]
  ], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToApprover && !_vm.application_workflow_state),
      expression: "showAssignToApprover && !application_workflow_state"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Approver")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedActivity.assigned_approver),
        expression: "selectedActivity.assigned_approver"
      }],
      ref: "assigned_approver",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedActivity, "assigned_approver", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.selectedActivity.issuing_officers), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.makeMeApprover()
        }
      }
    }, [_vm._v("Assign to me")])])]
  ], 2)]), _vm._v(" "), (_vm.isFinalised) ? [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false
        })
      }
    }
  }, [_vm._v("Hide Application")]) : (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleConditions({
          show: false,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Hide Conditions")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Show Application")]), _c('br'), _vm._v(" "), ((!_vm.showingApplication || !this.unfinishedActivities.length) && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleConditions({
          show: true
        })
      }
    }
  }, [_vm._v("Show Conditions")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.isFinalised) ? [_vm._m(2)] : _vm._e(), _vm._v(" "), ((_vm.canIssueDecline && _vm.approvingApplication && !_vm.application_workflow_state) || _vm.notOfficerWorkflow) ? [_c('div', [_vm._m(3), _vm._v(" "), (_vm.notOfficerWorkflow) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Show Application")]) : (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Hide Application2")]) : _vm._e(), _c('br')]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Show Application")]) : (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionLink()
      }
    }
  }, [_vm._v("Hide Conditions")]) : (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Hide Application")]) : _vm._e(), _c('br'), _vm._v(" "), (!_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionLink()
      }
    }
  }, [_vm._v("Show Conditions")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), ((_vm.canIssueDecline && _vm.approvingApplication && !_vm.application_workflow_state) || _vm.notOfficerWorkflow) ? [_vm._m(4)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [(_vm.showingApplication) ? [_vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRequestAmendmentButton && !_vm.application_workflow_state),
      expression: "showRequestAmendmentButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showRequestSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Request Amendment")]) : (!_vm.showRequestSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v("Request Amendment")]) : _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicantReturnButton()
      }
    }
  }, [_vm._v("Request Amendment")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssessmentConditionButton && !_vm.application_workflow_state),
      expression: "showAssessmentConditionButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showConditionSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Assessments & Conditions")]) : (!_vm.showConditionSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v("Assessments & Conditions")]) : _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionButton()
      }
    }
  }, [_vm._v("Assessments & Conditions")]), _c('br')])])] : [_vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackToProcessingButton && !_vm.application_workflow_state),
      expression: "showBackToProcessingButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationButton()
      }
    }
  }, [_vm._v("Back to Processing")]), _c('br')])]), _vm._v(" "), (_vm.canReturnToConditions && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionOfficerReturnButton()
      }
    }
  }, [_vm._v("Return to Officer - Conditions")])])]) : _vm._e(), _vm._v(" "), (_vm.canProposeIssueOrDecline && (_vm.isSendingToAssessor || _vm.showingConditions) && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedLicence()
      }
    }
  }, [_vm._v("Propose Issue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedDecline()
      }
    }
  }, [_vm._v("Propose Decline")])])]) : _vm._e(), _vm._v(" "), (_vm.canProposeToOnlyDecline && (_vm.isSendingToAssessor || _vm.showingConditions) && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedDecline()
      }
    }
  }, [_vm._v("Propose Decline")])])]) : _vm._e()]], 2)], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canIssueDecline && _vm.isofficerfinalisation) ? [_c('IssueLicence', {
    attrs: {
      "application": _vm.application,
      "licence_activity_tab": _vm.selected_activity_tab_id,
      "applicantType": _vm.applicantType
    },
    on: {
      "action-tab": _vm.actionTabListener
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isSendingToAssessor || _vm.showingConditions) ? _c('ApplicationAssessments', {
    on: {
      "action-tab": _vm.actionTabListener
    }
  }) : _vm._e(), _vm._v(" "), (_vm.applicationDetailsVisible && _vm.showingApplication) ? [_c('div', [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    ref: "applicantTab",
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill",
      "href": '#' + _vm.applicantTab
    },
    on: {
      "click": function($event) {
        return _vm.selectApplicantTab()
      }
    }
  }, [_vm._v("Applicant")])]), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill",
        "href": '#' + _vm.activityTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.applicantTab
    }
  }, [(_vm.showingApplicant) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Applicant\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.detailsBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.detailsBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.name),
      expression: "application.org_applicant.name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.abn),
      expression: "application.org_applicant.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant, "abn", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.first_name),
      expression: "application.proxy_applicant.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.last_name),
      expression: "application.proxy_applicant.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.dob),
      expression: "application.proxy_applicant.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "dob", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.first_name),
      expression: "application.submitter.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.last_name),
      expression: "application.submitter.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.dob),
      expression: "application.submitter.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "dob", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.identificationBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.identificationBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org' && _vm.application.org_applicant.organisation.identification) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "name": "applicantIdentification",
      "src": _vm.application.org_applicant.organisation.identification
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.identification2) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "name": "applicantIdentification",
      "src": _vm.application.proxy_applicant.identification2
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter' && _vm.application.submitter.identification2) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'customer_id': _vm.application.submitter.id
      }
    }
  })], 1)])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.addressBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.addressBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org' && _vm.application.org_applicant.address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.line1),
      expression: "application.org_applicant.address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.locality),
      expression: "application.org_applicant.address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.state),
      expression: "application.org_applicant.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.postcode),
      expression: "application.org_applicant.address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.country),
      expression: "application.org_applicant.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.residential_address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.line1),
      expression: "application.proxy_applicant.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.locality),
      expression: "application.proxy_applicant.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.state),
      expression: "application.proxy_applicant.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.postcode),
      expression: "application.proxy_applicant.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.country),
      expression: "application.proxy_applicant.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter' && _vm.application.submitter.residential_address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.line1),
      expression: "application.submitter.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.locality),
      expression: "application.submitter.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.state),
      expression: "application.submitter.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.postcode),
      expression: "application.submitter.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.country),
      expression: "application.submitter.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.contactsBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.contactsBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('table', {
    ref: "contacts_datatable",
    staticClass: "hover table table-striped table-bordered dt-responsive",
    attrs: {
      "id": _vm.contacts_table_id,
      "cellspacing": "0",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.phone_number),
      expression: "application.proxy_applicant.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantPhoneNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.mobile_number),
      expression: "application.proxy_applicant.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantMobileNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.email),
      expression: "application.proxy_applicant.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantEmail",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "email", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.phone_number),
      expression: "application.submitter.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantPhoneNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.mobile_number),
      expression: "application.submitter.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantMobileNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.email),
      expression: "application.submitter.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantEmail",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "email", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Check List\n                                "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.checksBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.checksBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.checksBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("ID Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isIdNotChecked || _vm.isIdCheckUpdated) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptIdRequest()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAccepted) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckRequested) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Awaiting Update")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isIdNotChecked) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.application.proxy_applicant
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIdRequest()
      }
    }
  }, [_vm._v("Request Update")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckUpdated) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Request updated")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAccepted || _vm.isIdCheckRequested) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetIdRequest()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Character Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(!_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptCharacterRequest()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetCharacterRequest()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Returns Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReturnCheckButton),
      expression: "showReturnCheckButton"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptReturnRequest()
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showReturnCheckButton),
      expression: "!showReturnCheckButton"
    }],
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showReturnCheckButton),
      expression: "!showReturnCheckButton"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetReturnRequest()
      }
    }
  }, [_vm._v("Reset")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": _vm.activityTab
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.isApplicationLoaded && !_vm.showingApplicant) ? _c('Application', {
    attrs: {
      "form_width": "inherit",
      "withSectionsSelector": false
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_activity_tab_id),
      expression: "selected_activity_tab_id"
    }],
    attrs: {
      "type": "hidden",
      "id": "selected_activity_tab_id"
    },
    domProps: {
      "value": (_vm.selected_activity_tab_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_activity_tab_id = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [_c('AmendmentRequestDetails', {
      attrs: {
        "activity_id": activity.id
      }
    }), _vm._v(" "), (activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                                " + _vm._s(this.$slots.default) + "\n\n                                "), (_vm.showNavBarBottom) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.updatedFee) ? _c('span', {
    staticStyle: {
      "margin-right": "5px",
      "font-size": "18px",
      "display": "block"
    }
  }, [_c('strong', [_vm._v("Updated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.application_fee)))]), _vm._v(" "), _c('strong', [_vm._v("licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.licence_fee)))])]) : _vm._e(), _vm._v(" "), (_vm.showSpinner && _vm.showRequestSpinner) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Save Changes")]) : (_vm.showSpinner && !_vm.showRequestSpinner) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save_button()
      }
    }
  }, [_vm._v("Save Changes")])])])])])]) : _vm._e()], 2) : _vm._e()], 1)])])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinalDecision),
      expression: "showFinalDecision"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.application.processing_status.name === 'Approved') ? _c('div', {
    staticClass: "col-md-12 alert alert-success"
  }, [_c('p', [_vm._v("The licence has been issued and has been emailed to " + _vm._s(_vm.application.applicant) + ".")]), _vm._v(" "), _c('p', [_vm._v("Licence: "), _c('a', {
    attrs: {
      "href": _vm.application.permit,
      "target": "_blank"
    }
  }, [_vm._v("licence.pdf")])])]) : _vm._e(), _vm._v(" "), (_vm.application.processing_status.name !== 'Approved') ? _c('div', {
    staticClass: "col-md-12 alert alert-danger"
  }, [_c('p', [_vm._v("The application is not approved. An update to the status was emailed to " + _vm._s(_vm.application.applicant))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Decision\n                            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.decisionBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.decisionBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.decisionBody
    }
  }, _vm._l((_vm.application.activities.filter(function (activity) { return ['issue_refund', 'issued'].includes(activity.decision_action); })), function(activity) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('strong', [_vm._v(" ")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Licence Activity: " + _vm._s(activity.activity_name_str))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Decision: " + _vm._s(activity.processing_status.id === 'declined' ? activity.processing_status.name : activity.decision_action))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Start date: " + _vm._s(_vm._f("formatDateNoTime")(activity.processing_status.id === 'declined' ? '' : activity.start_date)))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Expiry date: " + _vm._s(_vm._f("formatDateNoTime")(activity.processing_status.id === 'declined' ? '' : activity.expiry_date)))])])])
  }), 0)])])])])])], 2)])]), _vm._v(" "), _c('ProposedDecline', {
    ref: "proposed_decline",
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('AmendmentRequest', {
    ref: "amendment_request",
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('ProposedLicence', {
    ref: "proposed_licence",
    attrs: {
      "can_view_richtext_src": _vm.application.can_view_richtext_src
    },
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  })], 1) : _c('div', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('center', [_c('i', {
    staticClass: "fa fa-4x fa-spinner fa-spin"
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46163050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/application.vue
// module id = 969
// module chunks = 0